<template>
  <div
    class="flex-column-section flex-align-items_center"
  >
    <i
      class="pi pi-upload"
      style="font-size: 1.5rem;"
    />
    <div class="flex-column-union flex-align-items_center">
      <span>
        {{ i18n.global.t(`${I18N_PREFIX}.dragOrClick`, {
          count: props.multiple ? 2 : 1,
          maxSize: formatFileSize(props.maxFileSizeBytes),
        }) }}
      </span>
      <span
        v-if="acceptedFileExtensions"
        style="text-align: center;"
      >
        ({{ acceptedFileExtensions }})
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  i18n,
} from '@i18n';
import {
  computed,
} from 'vue';

import {
  MAXIMUM_FILE_SIZE,
  formatFileSize, getFileExtensions,
} from '@/constants/file-upload.ts';
import {
  EMimeType,
} from '@/types/mime.ts';

const I18N_PREFIX = 'components/upload-field/upload-field';

const props = withDefaults(defineProps<{
  /**
   * The accept attribute is a type safe implementation of the accept
   * attribute of the <input type="file">
   * https://developer.mozilla.org/de/docs/Web/HTML/Reference/Elements/input/file#accept
   *
   * If the list is empty of undefined the file types are not restricted
   *
   * This attribute is required, because uploading of arbitrary files is considered a major security risk:
   * https://nitrexgroup.atlassian.net/browse/QMU-4711
   */
  accept: EMimeType[],
  /**
   * The Boolean multiple attribute, if set, means the form control accepts one or
   * more values.
   */
  multiple?: boolean,
  maxFileSizeBytes?: number,
}>(), {
  maxFileSizeBytes: MAXIMUM_FILE_SIZE,
});
const acceptedFileExtensions = computed<string>(() => {
  return getFileExtensions(props.accept)
    .sort((a, b) => a.localeCompare(b))
    .map((extension) => `.${extension}`)
    .join(', ');
});
</script>
